/**
 * Generated bundle index. Do not edit.
 */

export * from './index';



// WEBPACK FOOTER //
// ../../../../../src/material-moment-adapter/material-moment-adapter_public_index.ts